module.exports = __webpack_public_path__ + "img/CClogo-horizontal-white.e70ff363.png";